import store from '../store';
import { waitUntil, save, load, logX, parseJSON } from '../common/libs/utils';
import { getHistory } from "./history";


export const setup = async () => {
	const params = new URLSearchParams(window.location.search);
	// const app = params.get('app') || '3164';
	let app = params.get('app') || params.get('bid') || '0';
	let name = params.get('name') || '';
	let locale = params.get('locale') || 'ja_JP';
	let color = params.get('color');
	let start = params.get('start') || '';
	let client = (params.get('client') || '').toLowerCase();
	let uid = params.get('uid');
	let mode = params.get('mode') || 'normal';
	let style = params.get('style') || '';
	let bot;

	let config = params.get('config');
	if (config) {
		try {
			config = JSON.parse(unescape(atob(config)));
			({ app = app, name = name, locale = locale, color = color, start = start, client = client, mode = mode, uid = uid, mode = mode } = config);
		} catch (ex) {
			console.error('Can not parse config', config);
		}
	}

	let readonly = mode === 'history';

	if (load('preview')) {
		const bot_preview = parseJSON(load('preview'));
		app = bot_preview.bot.id;
		start = bot_preview.start;
		bot = bot_preview.bot;
		name = name || bot_preview.name;
		window.$bot_data = bot;
		save('preview');
	}

	if (readonly) {
		await getHistory(uid);
		store.state.reversed = true;
		let token = params.get('token');
		window.token = token;
		logX('TOKEN', token);
	}

	if (mode !== 'draft' && !bot) {
		const script = document.createElement('script');
		// script.setAttribute('src', `${client === 'bizki' ? 'https://botdv.s3.amazonaws.com' : process.env.VUE_APP_BOT_HOST}/${app}_${locale}.js?v=${Math.random()}`);
		script.setAttribute('src', `${process.env.VUE_APP_BOT_HOST.replace(/{(.*?)}/g, (_, e) => window.location[e])}/${app}_${locale}.js?v=${Math.random()}`);
		document.head.appendChild(script);
		await waitUntil(() => window.$bot_data);
		bot = window.$bot_data;
	}

	bot = bot ?? { id: 0, name: 'Loading' };

	if(typeof bot.style === 'string') {
		bot.style = parseJSON(bot.style);
		color = color ?? bot.style?.display?.theme_color;
		name = name ?? bot.style?.display?.title;
	}

	if (client === 'bizki') {
		store.state.reversed = true;
		store.state.noWait = true;
	}

	
	if (/^[a-f\d]{3,8}$/i[Symbol.match](color)) {
		color = `#${color}`;
	}

	color = color ?? '#1968e5';

	document.body.style.setProperty('--clrTheme', color);
	store.state.client = client;
	store.state.start = start;
	store.state.readonly = readonly;
	store.state.uid = uid;
	store.state.bid = app;
	store.state.mode = mode;
	store.state.name = name || bot.name;
	store.state.bot = bot || { id: 0, name: 'Loading' };
	store.state.style = style;

	logX('BOT INFO', 'salmon', bot);
}